import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import "@fontsource-variable/inter";
import "@fontsource-variable/geist-mono";
// Load @myela/ui's compiled CSS (via its barrel's `import "./myela.css"`) BEFORE
// the app's Tailwind, so app utilities — incl. responsive sm/md/lg/xl variants —
// win the cascade. Matches the prod build's link order; without this the dev
// server injects the library CSS last and it clobbers every responsive utility.
import "@myela/ui";
import "./index.css";
import "../myela.css";
import { router } from "./routes";
import { BRAND, productName } from "@/lib/brand";

document.title = `${productName()} Partner Portal`;
document.documentElement.setAttribute("data-brand", BRAND.dbaName);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
